//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {
        return {
          title: [],
          list: []
        }
      }
    }
  },
  data () {
    return {
      type: 'model'  //model表示html组件形式，el表示js代码唤起的方式
    }
  },
  methods: {
    change () {
      if (this.type === 'model') {
        this.$emit('input', false)
      } else {
        this.value = false
      }
    },
    alert (type) {
      this.type = type
      this.$emit('input', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiAlert/uiAlert.vue